/**
 * The Site package's identity.
 *
 * A runtime module id is `<npm package>/modules/<module key>`, so the package name is part of the id
 * and two packages cannot collide by accident. What this package holds is the Public surface a phis
 * installation ships with -- and it is an ordinary Module, replaceable like any other.
 */
export const PHI_DEV_RUNTIME_MODULE_ID = "@phis/dev/modules/site";
export const PHI_DEV_LANDING_ROUTE_PRESET_KEY = "dev-landing-page";
export const PHI_DEV_HOME_ROUTE_PRESET_KEY = "dev-home-page";
/** The three pages the Home cards lead to, under one Docs entry in the Public header. */
export const PHI_DEV_DOCS_FOUNDATIONS_ROUTE_PRESET_KEY = "dev-docs-foundations-page";
export const PHI_DEV_DOCS_MODULES_ROUTE_PRESET_KEY = "dev-docs-modules-page";
export const PHI_DEV_DOCS_ADDONS_ROUTE_PRESET_KEY = "dev-docs-add-ons-page";
